export default __webpack_public_path__ + "static/media/icon-very-sad-face-empty.6bd1eb10.svg";